import React from 'react';
import { Smartphone, Globe, Download } from 'lucide-react';

const DownloadSection = () => {
  return (
    <section id="descarga" className="reveal relative py-24 px-6 bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="section-divider mb-12"></div>

        <div className="text-center mb-16 reveal">
          <h2 className="section-title text-4xl md:text-6xl font-bold mb-6 glow-orange">
            Accede al Conocimiento
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Elige tu puerta hacia el universo extendido. Android, web o ambos.
            El infierno te espera en cualquier dispositivo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto mb-16">
          <div className="card-inferno reveal p-10 text-center" style={{ transitionDelay: '50ms' }}>
            <Smartphone className="w-20 h-20 text-orange-500 mx-auto mb-6 animate-float" />
            <h3 className="text-3xl font-bold mb-4 text-white">
              Aplicación Android
            </h3>
            <p className="text-gray-400 mb-8 leading-relaxed">
              Lleva el universo en tu bolsillo. Escanea QRs directamente desde el libro
              y desbloquea contenido exclusivo al instante.
            </p>
            <button className="btn-inferno w-full">
              <Download size={24} />
              Descargar en Google Play
            </button>
            <p className="text-sm text-gray-500 mt-4">
              Próximamente disponible
            </p>
          </div>

          <div className="card-inferno reveal p-10 text-center" style={{ transitionDelay: '130ms' }}>
            <Globe className="w-20 h-20 text-red-500 mx-auto mb-6 animate-float" style={{ animationDelay: '1s' }} />
            <h3 className="text-3xl font-bold mb-4 text-white">
              Portal Web
            </h3>
            <p className="text-gray-400 mb-8 leading-relaxed">
              Accede desde cualquier navegador. Perfecto para usuarios de PC y Apple.
              La experiencia completa sin necesidad de instalación.
            </p>
            <a
              href="https://portal.grmeneghetti.com.ar/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-inferno w-full"
            >
              <Globe size={24} />
              Acceder al Portal
            </a>
            <p className="text-sm text-green-500 mt-4">
              ✓ Disponible ahora
            </p>
          </div>
        </div>

        <div className="inferno-panel reveal border-l-4 border-orange-500 p-8 max-w-4xl mx-auto">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <img
                src="/logo2.png"
                alt="App Icon"
                className="w-16 h-16 object-contain"
              />
            </div>
            <div>
              <h4 className="text-xl font-bold text-orange-500 mb-2">
                ¿Cómo funciona?
              </h4>
              <p className="text-gray-300 leading-relaxed mb-2">
                Dentro de cada libro de la trilogía encontrarás la página de un Grimorio perdido, el sello central es más de lo que parece. Escanéalos con la app o ingrésalos manualmente en el portal web.
              </p>
              <p className="text-gray-400 text-sm leading-relaxed">
                Cada código desbloquea contenido único: historias de demonios, biografías
                de personajes, descripciones de reliquias místicas, mapas de lugares sagrados
                y galerías de arte exclusivo.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-16 reveal">
          <p className="text-2xl text-gray-300 mb-4">
            <span className="text-red-500 font-bold glow-red">El infierno te acompaña</span>
          </p>
          <p className="text-lg text-gray-400">
            Ahora y siempre
          </p>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;
